export const ENVIRONMENTS = ['development', 'test', 'stage', 'production'];
